import { createContext, useEffect, useState } from "react";
import { TAuthContext, TAuthCredentials, TAuthData, TAuthProviderProps } from "./AuthProvider.type";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../Services/Database/Firebase.service";
import { getUserData, getUserRole } from "../../Services/User/GetUserData.service";
import Cookies from "js-cookie";

export const AuthContext = createContext<TAuthContext | null>(null);

const AuthProvider: React.FC<TAuthProviderProps> = ({ children }) => {
    const [user, setUser] = useState<TAuthData | null>(null);
    const [prevUserCredentials, setPrevUserCredentials] = useState<TAuthCredentials | null>(null);
    const [token, setToken] = useState<string | null>(null);

    useEffect(()=> {
        onAuthStateChanged(auth, async (firebaseUser) => {
            if(!firebaseUser) {
                setUser(null);
                setToken(null);
                Cookies.remove('authtoken');
                return;
            }

            try {
                const currentUserToken = await firebaseUser.getIdToken() ?? null;
                setToken(currentUserToken);

                const { hasRole } = await getUserRole(firebaseUser.uid);
                if(hasRole){
                    const currentUserData: TAuthData = await getUserData(firebaseUser);
                    setUser(currentUserData);
                }else {
                    setUser(null);
                }
            } catch (error) {
                console.error(error);
                setUser(null);
                setToken(null);
            }
        });
    }, [])

    return (
        <AuthContext.Provider value={{ user, prevUserCredentials, setPrevUserCredentials,  token  }}>
            {children}
        </AuthContext.Provider>
    )
} 

export default AuthProvider;